import { BaseModel, fillOwnProperties } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export default class LandingFeedbackField extends BaseModel {
  static override constructorName = 'LandingFeedbackField'

  _index: string = ''
  name: string = ''
  type: string = ''
  'is_required': boolean = false

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data, ['_index', 'is_required'])

      this._index = String(data._index ?? '')
      this.is_required = Boolean(Number(data.is_required))
    }
  }
}
